import { render, staticRenderFns } from "./MMClose.vue?vue&type=template&id=7d790e42&"
import script from "./MMClose.vue?vue&type=script&lang=js&"
export * from "./MMClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports